//<editor-fold desc="node core modules">
// const path = require('path');
//</editor-fold>

//<editor-fold desc="npm modules">
// const fs = require('fs-extra');
const extend = require('extend');
const Q = require('q');
const _ = require('underscore');
// const moment = require('moment');
// const URI = require('urijs');
//</editor-fold>

/**
 * NL类库
 *
 * @module nllib
 */

/**
 * 等待若干秒执行某操作
 *
 * @class nllib/src/common/wait_some_seconds
 * @static
 *
 * @param {object} pParameter
 * @param {int} pParameter.seconds 秒数，默认为2
 * @param {function} pParameter.handler_per_second 每秒执行一次的handler
 * <div style="margin-top:1em;"></div>
 * <div>方法签名：</div>
 * <div>const handler_per_second = function(args) {</div>
 * <div>const seconds = args.seconds;</div>
 * <div>}</div>
 * @return {object} 等待若干秒之后的promise
 *
 * @demo src/common/wait_some_seconds/1.0.1/demo/index.demo.js
 */
const wait_some_seconds = function (pParameter) {
    const default_parameter = {};
    default_parameter.seconds = 2;
    default_parameter.handler_per_second = null;

    const parameter = extend({}, default_parameter, pParameter);

    const __seconds = parameter.seconds;
    const handler_per_second = parameter.handler_per_second;

    const defer = Q.defer();

    let seconds = __seconds;
    const id_setInterval = setInterval(function () {
        if (seconds < 0) {
            clearInterval(id_setInterval);
            defer.resolve();
            return;
        }

        if (_.isFunction(handler_per_second)) {
            handler_per_second({
                seconds,
            });
        }
        seconds--;
    }, 1000);
    return defer.promise;
};

module.exports = wait_some_seconds;
